import * as tslib_1 from "tslib";
import "es6-promise";
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import VueI18n from "vue-i18n";
import VueRouter from "vue-router";
import Mixins from "vue-mixins";
import xamatron from "xamatron";
import "components";
import i18n from "i18n";
import { routes } from "views";
import { store } from "store";
import { getQueryStringArgs } from "common";
import "../components/KkPopup";
Vue.mixin(Mixins);
Vue.use(VueRouter);
Vue.use(VueI18n);
var KkRoot = /** @class */ (function (_super) {
    tslib_1.__extends(KkRoot, _super);
    function KkRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        return _this;
    }
    Object.defineProperty(KkRoot.prototype, "currentUser", {
        get: function () {
            return store.currentUser;
        },
        enumerable: true,
        configurable: true
    });
    KkRoot.prototype.getSiteUrl = function (path) {
        var baseUrl = "https://kunniakierros.fi/" + this.$i18n.locale + "/";
        return baseUrl + path;
    };
    KkRoot.prototype.created = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        store.identity = {
                            deviceId: this.getDeviceId(),
                            accessToken: localStorage.getItem("accessToken") || null,
                        };
                        xamatron.setBackButtonHandler(function () { return _this.back(); });
                        xamatron.initialNotification;
                        this.initAxios();
                        // this.$router.push(store.identity.accessToken ? "/home" : "/login");
                        this.$router.push(store.identity.accessToken ? "/home" : "/start");
                        return [4 /*yield*/, this.privacyPopup()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KkRoot.prototype.privacyPopup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var showCookieInfo;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get("applicationsettings/cookie-info-status/" + store.identity.deviceId)];
                    case 1:
                        showCookieInfo = (_a.sent()).data.showCookieInfo;
                        if (showCookieInfo) {
                            store.popup.title = "";
                            store.popup.description = this.$t("loginView.cookieInfo");
                            store.popup.visible = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    KkRoot.prototype.initAxios = function () {
        var _this = this;
        axios.defaults.baseURL = getQueryStringArgs().apiurl || "https://kunniakierros.fi/api/v1/";
        axios.interceptors.request.use(function (config) {
            if (store.identity.accessToken)
                config.headers["Authorization"] = "AccessToken " + store.identity.deviceId + " " + store.identity.accessToken;
            return config;
        });
        axios.interceptors.response.use(null, function (err) {
            if (err.response.status == 401) {
                localStorage.removeItem("accessToken");
                // alert("User authentication expired.");
                location.reload();
                store.popup.title = _this.$t("loginView.authErrorTitle");
                store.popup.description = _this.$t("loginView.authErrorDescription");
                store.popup.visible = true;
            }
            return Promise.reject(err);
        });
    };
    KkRoot.prototype.back = function () {
        if (this.$route.name == "HomeView" || this.$route.name == "Start")
            xamatron.exitApplication();
        else
            this.$router.go(-1);
    };
    KkRoot.prototype.getDeviceId = function () {
        var id = localStorage.getItem("deviceId");
        if (!id) {
            id = tslib_1.__spread(Array(32)).map(function (i) { return Math.floor(Math.random() * 16).toString(16); }).join("");
            localStorage.setItem("deviceId", id);
        }
        return id;
    };
    KkRoot = tslib_1.__decorate([
        Component({
            router: new VueRouter({
                mode: "abstract",
                linkActiveClass: "active",
                routes: routes
            }),
            i18n: new VueI18n(tslib_1.__assign({ locale: "fi", fallbackLocale: "fi" }, i18n))
        })
    ], KkRoot);
    return KkRoot;
}(Vue));
export default KkRoot;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/KkRoot.vue
// module id = 51
// module chunks = 0